export default __webpack_public_path__ + "static/media/quickSightUser.062dfabc.svg";